import { render, staticRenderFns } from "./AiStaff.vue?vue&type=template&id=fde1a77e"
import script from "./AiStaff.vue?vue&type=script&lang=js"
export * from "./AiStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports